import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'lgnwt/:param',
    loadChildren: () =>
      import('./pages/sso-login/sso-login.module').then(m => m.SsoLoginPageModule)
  },
  {
    path: 'api/sso/v2/:reqType',
    loadChildren: () =>
      import('./pages/sso-login/sso-login.module').then(m => m.SsoLoginPageModule)
  },
  {
    path: '',
    redirectTo: 'login-via-otp',
    pathMatch: 'full',
  },
  {
    path: 'theme',
    loadChildren: () =>
      import('./pages/ui-only/theme/theme.module').then(
        (m) => m.ThemePageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/ui-only/login/login.module').then(
        (m) => m.LoginPageModule
      ),
  },
  {
    path: 'search-distributor',
    loadChildren: () =>
      import(
        './pages/ui-only/search-distributor/search-distributor.module'
      ).then((m) => m.SearchDistributorPageModule),
  },

  {
    path: 'main',
    loadChildren: () =>
      import('./pages/ui-only/main/main.module').then((m) => m.MainPageModule),
  },
  {
    path: 'smart-saver',
    loadChildren: () =>
      import('./pages/ui-only/smart-saver/smart-saver.module').then(
        (m) => m.SmartSaverPageModule
      ),
  },

  {
    path: 'main',
    loadChildren: () =>
      import('./pages/ui-only/main/main.module').then((m) => m.MainPageModule),
  },

  // {
  //   path: 'fund-details',
  //   loadChildren: () =>
  //     import('./pages/ui-only/fund-details/fund-details.module').then(
  //       (m) => m.FundDetailsPageModule
  //     ),
  // },
  {
    path: 'redeem-page',
    loadChildren: () =>
      import('./pages/ui-only/redeem-page/redeem-page.module').then(
        (m) => m.RedeemPagePageModule
      ),
  },
  {
    path: 'switch-page',
    loadChildren: () =>
      import('./pages/ui-only/switch-page/switch-page.module').then(
        (m) => m.SwitchPagePageModule
      ),
  },
  {
    path: 'detail-page',
    loadChildren: () =>
      import('./pages/ui-only/detail-page/detail-page.module').then(
        (m) => m.DetailPagePageModule
      ),
  },
  {
    path: 'login-master',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'master',
    loadChildren: () =>
      import('./pages/master/master.module').then((m) => m.MasterPageModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'banks',
    loadChildren: () =>
      import('./pages/ui-only/bank/banks/banks.module').then(
        (m) => m.BanksPageModule
      ),
  },
  {
    path: 'bank-deatil',
    loadChildren: () =>
      import('./pages/ui-only/bank/bank-detail/bank-detail.module').then(
        (m) => m.BankDetailPageModule
      ),
  },
  {
    path: 'add-bank',
    loadChildren: () =>
      import('./pages/ui-only/bank/add-bank/add-bank.module').then(
        (m) => m.AddBankPageModule
      ),
  },
  {
    path: 'master/mandate',
    loadChildren: () =>
      import('./pages/mandate/mandate.module').then(
        (m) => m.MandatePageModule
      ),
  },
  {
    path: 'portfolio',
    loadChildren: () => import('./pages/portfolio/portfolio.module').then(m => m.PortfolioPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },




  {
    path: 'master',
    children: [
      // {
      //   path: '',
      //   redirectTo: 'home',
      //   pathMatch: 'full',
      // },
      // {
      //   path: 'reports',
      //   loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule)
      // },
      // {
      //   path: 'fund-detail',
      //   loadChildren: () => import('./pages/fund-details/fund-details.module').then( m => m.FundDetailsPageModule)
      // },
      {
        path: 'discover-detail',
        loadChildren: () => import('./pages/discover-detail/discover-detail.module').then(m => m.DiscoverDetailPageModule)
      },
      {
        path: 'investment-details',
        loadChildren: () => import('./pages/investment-details/investment-details.module').then(m => m.InvestmentDetailsPageModule)
      },
      {
        path: 'banks',
        loadChildren: () => import('./pages/banks/banks.module').then(m => m.BanksPageModule)
      },
      {
        path: 'bank-details',
        loadChildren: () => import('./pages/bank-details/bank-details.module').then(m => m.BankDetailsPageModule)
      },
      {
        path: 'add-bank',
        loadChildren: () => import('./pages/add-bank/add-bank.module').then(m => m.AddBankPageModule)
      }
    ]
  },
  {
    path: 'processing',
    loadChildren: () => import('./pages/processing/processing.module').then(m => m.ProcessingPageModule)
  },
  {
    path: 'mandate',
    loadChildren: () => import('./pages/mandate/mandate.module').then(m => m.MandatePageModule)
  },
  {
    path: 'add-mandate',
    loadChildren: () => import('./pages/add-mandate/add-mandate.module').then(m => m.AddMandatePageModule)
  },
  {
    path: 'mandate-details',
    loadChildren: () => import('./pages/mandate-details/mandate-details.module').then(m => m.MandateDetailsPageModule)
  },
  {
    path: 'security-options',
    loadChildren: () => import('./pages/security-options/security-options.module').then(m => m.SecurityOptionsPageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordPageModule)
  },
  {
    path: 'change-investor',
    loadChildren: () => import('./pages/change-investor/change-investor.module').then(m => m.ChangeInvestorPageModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportPageModule)
  },
  {
    path: 'buy-more',
    loadChildren: () => import('./pages/buy-more/buy-more.module').then(m => m.BuyMorePageModule)
  },
  {
    path: 'sip',
    loadChildren: () => import('./pages/sip/sip.module').then(m => m.SipPageModule)
  },
  {
    path: 'swp',
    loadChildren: () => import('./pages/swp/swp.module').then(m => m.SwpPageModule)
  },
  {
    path: 'stp',
    loadChildren: () => import('./pages/stp/stp.module').then(m => m.StpPageModule)
  },
  {
    path: 'switch',
    loadChildren: () => import('./pages/switch/switch.module').then(m => m.SwitchPageModule)
  },
  {
    path: 'redeem',
    loadChildren: () => import('./pages/redeem/redeem.module').then(m => m.RedeemPageModule)
  },
  {
    path: 'transaction-details',
    loadChildren: () => import('./pages/transaction-details/transaction-details.module').then(m => m.TransactionDetailsPageModule)
  },
  {
    path: 'transaction-details-data',
    loadChildren: () => import('./pages/transaction-details-data/transaction-details-data.module').then(m => m.TransactionDetailsDataPageModule)
  }, {
    path: 'fund-details',
    loadChildren: () => import('./pages/fund-details/fund-details.module').then(m => m.FundDetailsPageModule)
  },
  {
    path: 'select',
    loadChildren: () => import('./pages/select/select.module').then(m => m.SelectPageModule)
  }, {
    path: 'confirmation',
    loadChildren: () => import('./pages/confirmation/confirmation.module').then(m => m.ConfirmationPageModule)
  },
  {
    path: 'bse-authentication',
    loadChildren: () => import('./pages/bse-authentication/bse-authentication.module').then(m => m.BSEAuthenticationPageModule)
  },
  {
    path: 'initiate-payment',
    loadChildren: () => import('./pages/initiate-payment/initiate-payment.module').then(m => m.InitiatePaymentPageModule)
  },
  {
    path: 'processing-payment',
    loadChildren: () => import('./pages/processing-payment/processing-payment.module').then(m => m.ProcessingPaymentPageModule)
  },
  {
    path: 'payment-confirmation',
    loadChildren: () => import('./pages/payment-confirmation/payment-confirmation.module').then(m => m.PaymentConfirmationPageModule)
  },
  {
    path: 'error-processing',
    loadChildren: () => import('./pages/error-processing/error-processing.module').then(m => m.ErrorProcessingPageModule)
  },
  {
    path: 'error-confirmation',
    loadChildren: () => import('./pages/error-confirmation/error-confirmation.module').then(m => m.ErrorConfirmationPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'authentication',
    loadChildren: () => import('./pages/authentication/authentication.module').then(m => m.AuthenticationPageModule)
  },
  {
    path: 'scheme-search',
    loadChildren: () => import('./pages/scheme-search/scheme-search.module').then(m => m.SchemeSearchPageModule)
  },
  {
    path: 'inappbrowser',
    loadChildren: () => import('./pages/inappbrowser/inappbrowser.module').then(m => m.InappbrowserPageModule)
  }, {
    path: 'non-client-reports',
    loadChildren: () => import('./pages/non-client-reports/non-client-reports.module').then(m => m.NonClientReportsPageModule)
  },
  {
    path: 'aum-reports',
    loadChildren: () => import('./pages/aum-reports/aum-reports.module').then(m => m.AumReportsPageModule)
  },
  {
    path: 'consolidated-reports',
    loadChildren: () => import('./pages/consolidated-reports/consolidated-reports.module').then(m => m.ConsolidatedReportsPageModule)
  },
  {
    path: 'sip-book',
    loadChildren: () => import('./pages/sip-book/sip-book.module').then(m => m.SipBookPageModule)
  }, {
    path: 'login-via-otp',
    loadChildren: () => import('./pages/login-via-otp/login-via-otp.module').then(m => m.LoginViaOtpPageModule)
  },
  {
    path: 'enable-auth',
    loadChildren: () => import('./pages/enable-auth/enable-auth.module').then(m => m.EnableAuthPageModule)
  },
  {
    path: 'upload-mandate',
    loadChildren: () => import('./pages/upload-mandate/upload-mandate.module').then(m => m.UploadMandatePageModule)
  }, {
    path: 'payment-gateway',
    loadChildren: () => import('./pages/payment-gateway/payment-gateway.module').then(m => m.PaymentGatewayPageModule)
  },
  {
    path: 'onboard',
    loadChildren: () => import('./pages/onboard/onboard.module').then(m => m.OnboardPageModule)
  },
  {
    path: 'gws-blank-page',
    loadChildren: () => import('./gws-blank-page/gws-blank-page.module').then(m => m.GwsBlankPagePageModule)
  },
  {
    path: 'upload-signature',
    loadChildren: () => import('./pages/upload-signature/upload-signature.module').then(m => m.UploadSignaturePageModule)
  },
  {
    path: 'payment-gateway-holding',
    loadChildren: () => import('./pages/payment-gateway-holding/payment-gateway-holding.module').then(m => m.PaymentGatewayHoldingPageModule)
  },
  {
    path: 'payment-gateway-success',
    loadChildren: () => import('./pages/payment-gateway-success/payment-gateway-success.module').then(m => m.PaymentGatewaySuccessPageModule)
  },
  {
    path: 'payment-gateway-failure',
    loadChildren: () => import('./pages/payment-gateway-failure/payment-gateway-failure.module').then(m => m.PaymentGatewayFailurePageModule)
  },
  {
    path: 'authenticate-order',
    loadChildren: () => import('./pages/authenticate-order/authenticate-order.module').then(m => m.AuthenticateOrderPageModule)
  },
  {
    path: 'confirmation-fa',
    loadChildren: () => import('./pages/confirmation-fa/confirmation-fa.module').then(m => m.ConfirmationFAPageModule)
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
